<template>
    <div class="orderItem" @click="toDetails">
        <div class="orderTop van-hairline--bottom">
            <div class="orderSn">
                <img class="typeIcon" v-if="orderInfo.deviceType.value === 'CHARGER'"
                     src="../../../../assets/images/ic_order_xian.png" alt=""/>
                <img class="typeIcon" v-else src="../../../../assets/images/ic_order_bao.png" alt=""/>
                <span>订单号：{{orderInfo.orderSn}}</span>
            </div>
            <div class="orderStatus" :class="getStatusClass(orderInfo.status)">{{statusObject[orderInfo.status]}} <span
                v-if="orderInfo.finishWay !== 'NORMAL'">(手动完结)</span></div>
        </div>
        <div class="orderContent">
            <div class="userInfo">
                <img :src="orderInfo.avatar" alt="">
                <p>{{orderInfo.nickname}}</p>
                <p>{{orderInfo.mobile}}</p>
            </div>
            <div class="orderInfo">
                <p>地点：{{orderInfo.storeName}}</p>
                <p v-if="!isStore">时长：{{usingTimeFormat(orderInfo.usingTime)}}</p>
                <p v-if="orderInfo.status === 'USING' && !isStore">预算：{{orderInfo.money}}元</p>
                <p class="orderTime">{{orderInfo.createTime}}</p>
            </div>
            <div class="orderIncome">
                <img v-if="orderInfo.channel === 'WX'" src="../../../../assets/images/ic_wechat.png" alt="">
                <img v-if="orderInfo.channel === 'ZFB'" src="../../../../assets/images/ic_alipay.png" alt="">
                <template v-if="orderInfo.status === 'USING' && !isStore">
                    <img class="close_order" src="../../../../assets/images/ic_order_close.png" @click.stop="closeOrder" alt="">
                </template>
                <template v-else-if="orderInfo.status !== 'USING'">
                    <p v-if="!isStore">{{orderInfo.money}}元</p>
                    <p class="earnings">{{orderInfo.earnings}}元</p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    /*
    * 订单项
    * */
    import {Popup, Icon, Button} from 'vant';
    import {mapState} from 'vuex';
    export default {
        name: "OrderItem",
        components: {
            Popup,
            Icon,
            Button
        },
        props: {
            orderInfo: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                statusObject: {
                    'PENDING_PAYMENT': '待支付',
                    'PAYMENT_COMPLETED': '待出宝',
                    'USING': '使用中',
                    'DONE': '已完成',
                    'WAITING_PAID': '待扣款',
                    'REFUNDED': '已退款',
                    'BOUGHT': '已购买',
                    'OVERTIME_AND_PAYMENT': '逾期并已结算',
                }
            }
        },
        computed: {
            ...mapState(['isStore'])
        },
        methods: {
            toDetails() {
                if (this.isStore && this.orderInfo.orderDetail === 'CLOSE') return;
                this.toPage(`/orderDetails?orderSn=${this.orderInfo.orderSn}`)
            },
            closeOrder() {
                this.$emit('closeOrder', this.orderInfo.orderSn);
            },
            getStatusClass(status) {
                if (status === 'DONE' || status === 'REFUNDED') {
                    return 'c999999'
                }
                if (status === 'OVERTIME_AND_PAYMENT' || status === 'WAITING_PAID') {
                    return 'cff4141'
                }
                if (status === 'BOUGHT') {
                    return 'c28b836'
                }
            },
            usingTimeFormat(usingTime) {
                if (usingTime === '0') {
                    return usingTime + '分钟';
                }
                let day = parseInt(usingTime / 60 / 24);
                let hour = parseInt(usingTime / 60 % 24);
                let min = parseInt(usingTime % 60);
                let StatusMinute = "";
                if (day > 0) {
                    StatusMinute = day + "天";
                }
                if (hour > 0) {
                    StatusMinute += hour + "小时";
                }
                if (min > 0) {
                    StatusMinute += parseFloat(min) + "分钟";
                }
                return StatusMinute;
            }
        }
    }
</script>

<style lang='less' scoped>
    .orderItem {
        margin-bottom: 2vw;
        background-color: #fff;

        .orderTop {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 9.6vw;
            padding: 0 5.1vw 0 5.9vw;

            .orderSn {
                display: flex;
                align-items: center;
                font-size: 3.2vw;
                color: #999999;

                .typeIcon {
                    width: 4vw;
                    height: 5.1vw;
                    margin-right: 1.3vw;
                }
            }

            .orderStatus {
                font-size: 3.7vw;
                color: #43a2fe;

                &.c999999 {
                    color: #999999
                }

                &.cff4141 {
                    color: #ff4141;
                }

                &.c28b836 {
                    color: #28b836;
                }
            }
        }

        .orderContent {
            display: flex;
            padding: 3.1vw 5.3vw 2.1vw 1.5vw;

            .userInfo {
                width: 21.7vw;

                img {
                    display: block;
                    width: 12.9vw;
                    height: 12.9vw;
                    margin: 0 auto 2vw;
                    border-radius: 50%;
                }

                p {
                    font-size: 2.7vw;
                    line-height: 3.75vw;
                    text-align: center;
                    color: #000000;
                }
            }

            .orderInfo {
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                flex: 1;

                p {
                    font-size: 3.7vw;
                    color: #333333;
                    line-height: 5.3vw;

                    &.orderTime {
                        font-size: 2.9vw;
                        color: #999999;
                    }
                }
            }

            .orderIncome {
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: flex-end;

                img {
                    width: 4.8vw;
                    height: 4.8vw;
                    margin-bottom: 5vw;

                    &.close_order {
                        margin-top: 2.5vw;
                        margin-bottom: 0;
                    }
                }

                p {
                    font-size: 2.93vw;
                    color: #999999;

                    &.earnings {
                        font-size: 3.7vw;
                        color: #00a9f2;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/order/components/OrderItem.vue